var render = function render(){var _vm=this,_c=_vm._self._c;return _c('helmi-group-dashboard-card',{staticClass:"helmi-group-dashboard-cumulative-return",attrs:{"initializing":_vm.loadingCharts,"title":"Kuukausittainen tuotto","subtitle":"(Brutto)","fullscreen":"","use-theme":""}},[_c('h-line-echart',{attrs:{"title":_vm.echartsData.title,"labels":_vm.echartsData.labels,"series":_vm.echartsData.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }